module.exports = __webpack_public_path__ + "img/imageCardFive.35f2b42f.png";